<div class="z-50 relative flex lg:justify-end w-auto">
  <div
    class="flex flex-col w-max max-w-[90vw] transition-all duration-500 ease-in-out shadow-2xl pointer-events-auto h-max"
    [ngClass]="{
      'bg-white rounded-3xl shadow-xl/30 inset-shadow-sm': expansion,
      'rounded-[3.125]': !expansion,
    }"
  >
    <div
      class="bg-(--color-card-header) flex justify-between items-center py-0.5 px-3 transition-all duration-500 ease-in-out"
      [ngClass]="{
        'rounded-[3.125]': !expansion,
        'rounded-t-3xl px-2': expansion,
      }"
    >
      <div class="flex gap-2 text-base justify-center items-center relative">
        <mat-icon class="text-white!"> confirmation_number </mat-icon>
        <div class="font-bold text-white">
          Folio:
          <span class="font-medium text-white">
            {{ ticketDetail?.Key }}
          </span>
        </div>
        <div class="font-bold text-white">
          Estatus:
          <span class="font-medium text-white">
            {{ ticketDetail?.TicketState?.Description }}
          </span>
        </div>
      </div>

      <button
        matTooltip="{{ !expansion ? 'Maximizar' : 'Minimizar' }}"
        class="rounded-md size-10! border-2! bg-white! border-(--comp-icon-color-secondary)! justify-center items-center inline-flex!"
        matIconButton
        (click)="expansion = !expansion"
      >
        <mat-icon class="text-(--comp-icon-color-secondary)!">
          {{ !expansion ? 'fit_screen' : 'fullscreen_exit' }}
        </mat-icon>
      </button>
    </div>

    <div
      class="grid transition-[grid-template-rows,opacity] duration-500 ease-in-out"
      [ngClass]="{
        'grid-rows-[1fr] opacity-100': expansion,
        'grid-rows-[0fr] opacity-0': !expansion,
      }"
    >
      <div class="overflow-hidden">
        <div
          class="text-general text-(--brand-gray-dark) flex flex-col gap-2 px-6 py-4 bg-white rounded-b-3xl"
        >
          <div class="w-full shadow-xl h-52 p-2 rounded-xl">
            <google-map height="100%" width="100%" [center]="center" [zoom]="zoom">
              <map-marker [position]="center"></map-marker>
            </google-map>
          </div>
          @for (ticket of dataTicket; track $index) {
            <div class="flex gap-2 border-b border-gray-100 last:border-0 pb-1">
              <span class="font-bold">{{ ticket.nameData }}:</span>
              <span class="font-medium"> {{ ticket.value }}</span>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
